module.exports = __webpack_public_path__ + "src/assets/images/logo-hero-color.svg?282f46d423b769a6a8b18a65c96ad993";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-hero-color.svg
// module id = 1017
// module chunks = 1